import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "form"];

  openModal() {
    this.modalTarget.classList.add("show");
    this.modalTarget.style.display = "block";
    document.body.classList.add("modal-open");
  }

  closeModal() {
    this.modalTarget.classList.remove("show");
    this.modalTarget.style.display = "none";
    document.body.classList.remove("modal-open");
  }

  save(event) {
    event.preventDefault();
    const form = this.formTarget;
    const url = form.action;
    const formData = new FormData(form);

    fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          this.closeModal();
          $.notify("Enrolment updated successfully", "success");
          setTimeout(() => location.reload(), 1000);
        } else {
          return response.text().then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const error = doc.querySelector(".alert-danger")?.textContent || "Failed to update";
            $.notify(error, "danger");
          });
        }
      })
      .catch(() => {
        $.notify("An error occurred", "danger");
      });
  }
}